import { PaymentTypeEnum } from "./V2/gozer"

export const PaymentMethodTypes = [
    {
        name: "Cash",
        paymentMethodType: PaymentTypeEnum.CASH
    },
    {
        name: "Money Order",
        paymentMethodType: PaymentTypeEnum.MONEY_ORDER
    },
    {
        name: "Other",
        paymentMethodType: PaymentTypeEnum.OTHER
    },
    {
        name: "Credit Card",
        paymentMethodType: PaymentTypeEnum.CC
    },
    {
        name: "ACH",
        paymentMethodType: PaymentTypeEnum.ACH
    },
    {
        name: "Check",
        paymentMethodType: PaymentTypeEnum.CHECK
    }
].sort((a,b) => a?.name?.localeCompare(b?.name ?? "") ?? 0)